'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgRefresh } from '@common/icon';
import type { ErrorInfo, ReactNode } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { ErrorBoundary } from 'react-error-boundary';
interface StatisticsErrorBoundaryProps {
  children: ReactNode;
}
const StatisticsCardErrorFallback = t0 => {
  const $ = _c(4);
  const {
    resetErrorBoundary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="text-center text-Gray-500 typo-caption1">잠시 후 다시 시도해주세요</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgRefresh className="size-16 transition-transform duration-500 group-hover:rotate-180" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== resetErrorBoundary) {
    t3 = <section className="mx-20 mb-20 flex h-80 flex-col items-center justify-center gap-8 rounded-medium border border-Gray-200 bg-Gray-white" role="alert" aria-live="polite">{t1}<Button type="button" onClick={resetErrorBoundary} theme="secondary-fill" dimensions="H26" className="group" aria-label={"\uD1B5\uACC4 \uC815\uBCF4 \uB2E4\uC2DC \uBD88\uB7EC\uC624\uAE30"}>{t2}다시 시도</Button></section>;
    $[2] = resetErrorBoundary;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export const StatisticsErrorBoundary = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  const handleError = _temp;
  let t1;
  if ($[0] !== children) {
    t1 = <ErrorBoundary FallbackComponent={StatisticsCardErrorFallback} onError={handleError} onReset={_temp2}>{children}</ErrorBoundary>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(error, info) {
  console.error("Statistics Card Error:", error, info);
}
function _temp2() {
  window.location.reload();
}